import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "preview-video-page" }
const _hoisted_2 = { class: "detail-wrap dark-bg radius-middle" }
const _hoisted_3 = { class: "subTitle-with-line" }
const _hoisted_4 = { class: "sub-text" }
const _hoisted_5 = { class: "subTitle-with-line" }
const _hoisted_6 = { class: "sub-text" }
const _hoisted_7 = { class: "subTitle-with-line" }
const _hoisted_8 = { class: "sub-text" }
const _hoisted_9 = { class: "subTitle-with-line" }
const _hoisted_10 = { class: "sub-text" }
const _hoisted_11 = { class: "subTitle-with-line" }
const _hoisted_12 = { class: "sub-text" }
const _hoisted_13 = { class: "subTitle-with-line" }
const _hoisted_14 = { class: "video-wrap dark-bg radius-middle" }
const _hoisted_15 = { class: "video-container" }
const _hoisted_16 = { class: "player-wrapper" }
const _hoisted_17 = {
  class: "publishing-plate my-scroller",
  "element-loading-text": "获取作品TDK...",
  "element-loading-background": "rgba(0,0,0,0.8)"
}
const _hoisted_18 = { class: "publishing-header" }
const _hoisted_19 = { class: "publishing-template" }
const _hoisted_20 = { class: "publishing-item" }
const _hoisted_21 = { class: "publishing-title" }
const _hoisted_22 = { class: "publishing-info" }
const _hoisted_23 = { class: "publishing-item" }
const _hoisted_24 = { class: "publishing-title" }
const _hoisted_25 = { style: {"padding":"0"} }
const _hoisted_26 = { class: "publishing-info" }
const _hoisted_27 = { class: "tag-select-item" }
const _hoisted_28 = { style: {"font-weight":"bold"} }
const _hoisted_29 = { class: "tag-select-item" }
const _hoisted_30 = { style: {"font-weight":"bold"} }
const _hoisted_31 = { class: "publishing-item" }
const _hoisted_32 = { class: "publishing-title" }
const _hoisted_33 = { style: {"padding":"0"} }
const _hoisted_34 = { class: "publishing-info" }
const _hoisted_35 = { class: "action-buttons" }

import { ref, reactive, onMounted } from 'vue';
import { useRouter, useRoute } from "vue-router";
import { getAppVideoDetail } from '@/request/index';
import { useGenerateTDKData } from '@/utils/useProcessAndCheckMedia';
import useProcessMediaAccounts from '@/utils/useProcessAndCheckMedia';
import { ElMessage } from 'element-plus';
import VideoPlayer from "@/components/MediaPlayer/VideoPlayer.vue";
import { blobDownloadUpgrades } from "@/utils";
import workSharing from '@/views/workPlateform/components/workSharing.vue'
import setDistribution from '@/views/workManage/components/setDistribution.vue';
import { copyText } from '@/utils/index'
import { CopyDocument } from '@element-plus/icons-vue'
import { fetchGetAppUserInfo } from '@/request/aiAction';


export default /*@__PURE__*/_defineComponent({
  __name: 'previewVideo',
  props: {
  videoId: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const { processAndCheckMediaAccountsPromise } = useProcessMediaAccounts();
const props = __props

const router = useRouter();
const route = useRoute();
const publishDrawer = ref(false);
const bindMediaArr = ref([]);
let publishDrawerBtn = ref(false);

let info = ref({});
let infoMap = ref({});

function stripTagsKeepContent(text) {
  // 检查文本是否包含XML标签
  if (/<[a-z][\s\S]*>/i.test(text)) {
    // 如果有标签，则执行DOM解析并提取内容
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(text, 'text/xml');
    let textContent = '';
    xmlDoc.documentElement.childNodes.forEach(node => {
      textContent += node.textContent;
    });
    return textContent?.trim(); // 返回去除首尾空格的文本
  } else {
    // 如果没有标签，直接返回原始文本
    return text?.trim(); // 返回去除首尾空格的文本
  }
}
const getInfo = () => {
  getAppVideoDetail(props.videoId || route.query.id).then(res => {
    const { code, data } = res.data;
    if (code == 200) {
      info.value = { ...data, tags: ['Option1', 'Option2', 'Option3'] };
      infoMap.value = { ...data };

      getUserInfo()
    }
  })
}


const formatSecondsToTime = (milliseconds) => {
  // let milliseconds = seconds * 1000; // 转换为毫秒
  let hours = Math.floor(milliseconds / (1000 * 60 * 60));
  let minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
  let remainingSeconds = Math.floor((milliseconds % (1000 * 60)) / 1000);
  let millisecondsRemainder = milliseconds % 1000;

  // 确保小时、分钟、秒和毫秒始终显示两位数（对于小时，可能需要显示一位或两位）
  hours = String(hours).padStart(2, '0');
  minutes = String(minutes).padStart(2, '0');
  remainingSeconds = String(remainingSeconds).padStart(2, '0');
  millisecondsRemainder = String(millisecondsRemainder).substring(0, 3).padStart(3, '0');

  return `${hours}:${minutes}:${remainingSeconds}.${millisecondsRemainder}`;
}



let processAndCheckMediaAccountsFn = () => {
  publishDrawerBtn.value = true;
  processAndCheckMediaAccountsPromise().then((res) => {
    bindMediaArr.value = res.mediaIds
    // 输出检查结果
    publishDrawer.value = true;
    publishDrawerBtn.value = false;
  }).catch((error) => {
    publishDrawerBtn.value = false;
    console.error("操作失败", error);

  })

}

onMounted(() => {
  getInfo();
})
let popperHover = ref(false)
let copyTextGo = () => {
  let { videoMakeMediaUrl, name } = info.value
  let text = `【${name}】${videoMakeMediaUrl}`
  copyText(text)
}



// 获取用户信息
async function getUserInfo() {
  const res: any = await fetchGetAppUserInfo();
  if (res) {
    const { trade = "", profession = "", area = "" } = res.data.data;
    generateVideoTDKFn({ trade, profession, area, text: info.value.broadcastContent })
    // generateVideoTDKFn({ trade, profession, area, text: info.value.broadcastContent })
  }
}

// 获取视频tdk标签
let btnLoading = ref(false)
const tagOptions = ref([
])


let tdkData = ref({
  title: "",
  context: "",
  tag: '',
  contextAndText: '',
  tagArr: []
})

const { generateTDKData, getTDKData, getTagOptions } = useGenerateTDKData();
async function generateVideoTDKFn(inputs = {}) {
  btnLoading.value = true;
  const { tdkData: newTdkData, tagOptions: newTagOptions } = await generateTDKData(inputs);
  tdkData.value = newTdkData;
  tagOptions.value = newTagOptions;
  btnLoading.value = false;
}

let copyVideoTdkGo = () => {
  let { title, contextAndText } = tdkData.value
  copyText(`【${title}】${contextAndText}`)
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "title" }, "作品信息", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "sub-text-label" }, "作品名称：", -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(info).name), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "sub-text-label" }, "作品状态：", -1)),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(info).status ==
        0 ? '合成中' : '创作成功'), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "sub-text-label" }, "发音人：", -1)),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(info).timbreName), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "sub-text-label" }, "作品时长：", -1)),
        _createElementVNode("span", _hoisted_10, _toDisplayString(formatSecondsToTime(_unref(info).videoMakeDuration)), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "sub-text-label" }, "创作时间： ", -1)),
        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(info).createTime), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "sub-text-label" }, "播音内容：", -1)),
        _createVNode(_component_el_input, {
          value: stripTagsKeepContent(_unref(info).broadcastContent),
          autosize: { minRows: 20, maxRows: 20 },
          type: "textarea",
          disabled: ""
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          (_unref(info).videoMakeMediaUrl)
            ? (_openBlock(), _createBlock(VideoPlayer, {
                key: 0,
                "video-url": _unref(info).videoMakeMediaUrl,
                id: 'videoPlayer' + _unref(info).id,
                autoplay: true
              }, null, 8, ["video-url", "id"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_divider, { class: "custom-divider" }),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _cache[22] || (_cache[22] = _createElementVNode("p", null, "【AI助手已为您准备好了发布模板】经过优化的信息将有助于提升您的视频在搜索中的排名，并吸引更多观众的关注。", -1)),
            _cache[23] || (_cache[23] = _createTextVNode()),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              icon: _unref(CopyDocument),
              size: "small",
              onClick: _unref(copyVideoTdkGo)
            }, {
              default: _withCtx(() => _cache[21] || (_cache[21] = [
                _createTextVNode("一键复制")
              ])),
              _: 1
            }, 8, ["icon", "onClick"])), [
              [_directive_loading, _unref(publishDrawerBtn)]
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[25] || (_cache[25] = _createElementVNode("div", null, " 作品名称 ", -1)),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    icon: _unref(CopyDocument),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(copyText)(_unref(tdkData).title)))
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createTextVNode("复制")
                    ])),
                    _: 1
                  }, 8, ["icon"])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_el_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(tdkData).title), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    content: "点击生成或编辑视频标签，这些标签有助于增加视频的可见度。",
                    placement: "top-start"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_25, [
                        _cache[26] || (_cache[26] = _createTextVNode(" 作品标签 ")),
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InfoFilled)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    icon: _unref(CopyDocument),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(copyText)(_unref(tdkData).tag)))
                  }, {
                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                      _createTextVNode("复制")
                    ])),
                    _: 1
                  }, 8, ["icon"])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_el_select, {
                  modelValue: _unref(tdkData).tagArr,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tdkData).tagArr) = $event)),
                  disabled: "",
                  class: "tag-select",
                  multiple: "",
                  filterable: "",
                  "allow-create": "",
                  "default-first-option": "",
                  "reserve-keyword": false,
                  placeholder: "请为视频进行打标"
                }, {
                  label: _withCtx(({ label }) => [
                    _createElementVNode("span", _hoisted_27, [
                      _cache[28] || (_cache[28] = _createElementVNode("i", {
                        class: "ri-hashtag",
                        style: {"margin-right":"5px","color":"#a3c7ff"}
                      }, null, -1)),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(label), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagOptions.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_29, [
                            _cache[29] || (_cache[29] = _createElementVNode("i", {
                              class: "ri-hashtag",
                              style: {"margin-right":"5px","color":"#a3c7ff"}
                            }, null, -1)),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(item.label), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    content: "AI助理已根据内容生成作品描述，有助于提高视频的搜索排名和曝光率，吸引更多观众。",
                    placement: "top-start"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_33, [
                        _cache[30] || (_cache[30] = _createTextVNode(" 作品描述 ")),
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InfoFilled)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    icon: _unref(CopyDocument),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(copyText)(_unref(tdkData).contextAndText)))
                  }, {
                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                      _createTextVNode("复制")
                    ])),
                    _: 1
                  }, 8, ["icon"])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_el_input, {
                  value: _unref(tdkData).contextAndText,
                  autosize: { minRows: 5, maxRows: 5 },
                  type: "textarea",
                  disabled: ""
                }, null, 8, ["value"])
              ])
            ])
          ])
        ])), [
          [_directive_loading, _unref(btnLoading)]
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        (!props.videoId)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              plain: "",
              class: "action-btn",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).go(-1)))
            }, {
              default: _withCtx(() => _cache[32] || (_cache[32] = [
                _createTextVNode("返回")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "primary",
          class: "action-btn",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(blobDownloadUpgrades)(_unref(info).videoMakeMediaUrl, _unref(info).name)))
        }, {
          default: _withCtx(() => _cache[33] || (_cache[33] = [
            _createTextVNode("下载")
          ])),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          class: "action-btn",
          onClick: _unref(processAndCheckMediaAccountsFn)
        }, {
          default: _withCtx(() => _cache[34] || (_cache[34] = [
            _createTextVNode("发布")
          ])),
          _: 1
        }, 8, ["onClick"])), [
          [_directive_loading, _unref(publishDrawerBtn)]
        ]),
        _createVNode(_component_el_popover, {
          placement: "top-end",
          effect: "light",
          "popper-class": "work-sharing-popover",
          width: 530,
          trigger: "hover",
          onBeforeEnter: _cache[6] || (_cache[6] = ($event: any) => (_isRef(popperHover) //@ts-ignore
 ? popperHover.value = true : popperHover = true)),
          onHide: _cache[7] || (_cache[7] = ($event: any) => (_isRef(popperHover) //@ts-ignore
 ? popperHover.value = false : popperHover = false))
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              class: "action-btn share-btn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(popperHover) ? '点击复制链接' : '分享'), 1)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(workSharing, { details: _unref(info) }, null, 8, ["details"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: publishDrawer.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((publishDrawer).value = $event)),
      title: "发布面板"
    }, {
      default: _withCtx(() => [
        _createVNode(setDistribution, {
          publishDrawer: publishDrawer.value,
          "onUpdate:publishDrawer": _cache[8] || (_cache[8] = ($event: any) => ((publishDrawer).value = $event)),
          publishIdModel: _unref(route).query.id,
          "onUpdate:publishIdModel": _cache[9] || (_cache[9] = ($event: any) => ((_unref(route).query.id) = $event)),
          publishTitleModel: _unref(tdkData).title,
          "onUpdate:publishTitleModel": _cache[10] || (_cache[10] = ($event: any) => ((_unref(tdkData).title) = $event)),
          portfolioArr: [_unref(infoMap)],
          bindMediaArr: bindMediaArr.value,
          contentModel: _unref(tdkData).contextAndText,
          "onUpdate:contentModel": _cache[11] || (_cache[11] = ($event: any) => ((_unref(tdkData).contextAndText) = $event)),
          publishTagsModel: _unref(tdkData).tagArr,
          "onUpdate:publishTagsModel": _cache[12] || (_cache[12] = ($event: any) => ((_unref(tdkData).tagArr) = $event))
        }, null, 8, ["publishDrawer", "publishIdModel", "publishTitleModel", "portfolioArr", "bindMediaArr", "contentModel", "publishTagsModel"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})